import {
  linkedSignal,
  Resource,
  ResourceSnapshot,
  resourceFromSnapshots,
} from '@angular/core';

/**
 * Keeps the previous resolved value visible while a resource reloads (params change).
 * @see https://angular.dev/guide/signals/resource#composing-resources-with-snapshots
 */
export function withPreviousResourceValue<T>(input: Resource<T>): Resource<T> {
  const derived = linkedSignal<ResourceSnapshot<T>, ResourceSnapshot<T>>({
    source: input.snapshot,
    computation: (snap, previous) => {
      const kept = previousResolvedValue(previous?.value);
      if (snap.status === 'loading' && kept !== undefined) {
        return { status: 'loading' as const, value: kept };
      }
      if (snap.status === 'error' && kept !== undefined) {
        return { status: 'resolved' as const, value: kept };
      }

      return snap;
    },
  });

  return resourceFromSnapshots(derived);
}

function previousResolvedValue<T>(snap: ResourceSnapshot<T> | undefined): T | undefined {
  if (!snap || snap.status === 'error') {
    return undefined;
  }
  return snap.value;
}
